/**
 * Copy (user facing texts) for tooltips and warnings specific to
 * intermittent and isolated margin markets.
 */

/** Session status tooltip, same for every state (open/pre-close/closed/opening) */
export const MARKET_CLOSES_PERIODICALLY_LINK_TOOLTIP =
  'This market closes periodically. Positions cannot be updated while the market is closed, and order placement rules can vary. Learn More';

export const TOOLTIP_MARKET_ORDERS_CLOSED =
  'Market orders are not available while the market is closed.';

export const TOOLTIP_POST_ONLY_CLOSED =
  'Limit orders must be post-only while the market is closed.';

/** Buy/Sell blocked: wallet is open elsewhere and this market is isolated margin */
export function getIsolatedMarketRestrictionTooltip(market: string): string {
  return `${market} uses isolated margin. Close all open positions and cancel all open orders in other markets.`;
}

/** Buy/Sell blocked: wallet is open in an isolated margin market */
export function getOpenIsolatedMarketRestrictionTooltip(
  openIsolatedMarket: string
): string {
  return `Account has open orders or positions in the isolated margin market ${openIsolatedMarket}. Close them to trade other markets.`;
}
